import { getProjectManager, HEALTHCHECK_NAMES } from 'domain/shared/newProject';
import StaffingSections from './sections/StaffingSections';
import StaffingHealthchecks from './StaffingHealthchecks';
import BaseControl from '../BaseControl';
import { resolveControlsZone } from '../utils';
import { ControlData } from '../types';

type StaffingControlProps = {
  data: ControlData;
  showSections?: boolean;
};

export const staffingHealthcheckNames = [HEALTHCHECK_NAMES.STAFFING_RISKS];

export const staffingRiskIssueTypes = [
  HEALTHCHECK_NAMES.PROJECT_UNDERSTAFFED,
  HEALTHCHECK_NAMES.KEY_ROLE_UNSTAFFED,
  HEALTHCHECK_NAMES.REPLACEMENT_NOT_ASSIGNED,
  HEALTHCHECK_NAMES.TEAM_QUALITY_MISMATCH,
] as const;

const StaffingControl = ({ data, showSections = true }: StaffingControlProps) => {
  const projectManager = getProjectManager(data);
  const zone = resolveControlsZone({
    healthChecks: data?.health?.healthChecks,
    healthcheckNames: [...staffingHealthcheckNames],
    staffingRiskIssues: data?.staffingRisk?.issues,
    staffingRiskIssueTypes: [...staffingRiskIssueTypes],
  });
  return (
    <BaseControl
      title="Staffing"
      controlResponsible={projectManager}
      zone={zone}
      healthchecks={<StaffingHealthchecks data={data} />}
      sections={showSections ? <StaffingSections data={data} /> : null}
    />
  );
};
export default StaffingControl;
